import { render } from "./ProductPricingSection.vue?vue&type=template&id=68227e9e&scoped=true"
import script from "./ProductPricingSection.vue?vue&type=script&lang=js"
export * from "./ProductPricingSection.vue?vue&type=script&lang=js"

import "./ProductPricingSection.vue?vue&type=style&index=0&id=68227e9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68227e9e"]])

export default __exports__